import { AdminView } from '../enums';

// Lazy-initialized to avoid TDZ issues with enum imports
let _viewPaths: Record<AdminView, string> | null = null;

const getViewPaths = (): Record<AdminView, string> => {
  if (!_viewPaths) {
    _viewPaths = {
      [AdminView.DASHBOARD]: '/dashboard',
      [AdminView.CAMPAIGNS]: '/campaigns',
      [AdminView.SUBMISSIONS]: '/submissions',
      [AdminView.PROPOSALS]: '/proposals',
      [AdminView.TABLE]: '/table',
      [AdminView.REPORTS]: '/reports',
      [AdminView.ANALYTICS]: '/analytics',
      [AdminView.COMMUNITY]: '/community',
      [AdminView.MENU_BUILDER]: '/menu-builder',
      [AdminView.SETTINGS]: '/settings',
      [AdminView.USERS]: '/users',
      [AdminView.PROFILE]: '/profile',
      [AdminView.TRACE]: '/trace',
      [AdminView.MANAGER_DASHBOARD]: '/manager',
      [AdminView.MANAGERS_DASHBOARD]: '/managers-dashboard',
      [AdminView.SUBMIT_SUBMISSIONS]: '/submit',
    };
  }
  return _viewPaths;
};

const normalizePath = (path: string) => {
  const [base] = (path || '/').split('?');
  const trimmed = base.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed.toLowerCase();
};

export const pathToView = (path: string): AdminView | null => {
  const normalized = normalizePath(path);
  const paths = getViewPaths();
  const entry = Object.entries(paths).find(([, p]) => normalizePath(p) === normalized);
  return entry ? (entry[0] as AdminView) : null;
};

export const viewToPath = (view: AdminView): string => getViewPaths()[view] || '/dashboard';

// For backward compatibility, export VIEW_PATHS as a getter
export const VIEW_PATHS = new Proxy({} as Record<AdminView, string>, {
  get: (_, prop) => getViewPaths()[prop as AdminView],
  ownKeys: () => Object.keys(getViewPaths()),
  getOwnPropertyDescriptor: () => ({ enumerable: true, configurable: true }),
});
